import type { BriefTemplate, BriefTemplateLevel } from '@/entities/brief-template';

/** The workspace's own templates first, then wider levels: the nearer a template, the likelier the pick. */
const PICKER_LEVEL_ORDER: readonly BriefTemplateLevel[] = ['workspace', 'organization', 'system'];

export interface BriefTemplateLevelGroup<T> {
  level: BriefTemplateLevel;
  templates: T[];
}

/** Keeps the server order within a level and leaves out levels with nothing to pick. */
export function groupBriefTemplatesByLevel<T extends Pick<BriefTemplate, 'level'>>(
  templates: readonly T[],
): BriefTemplateLevelGroup<T>[] {
  return PICKER_LEVEL_ORDER.map((level) => ({
    level,
    templates: templates.filter((template) => template.level === level),
  })).filter((group) => group.templates.length > 0);
}
